import { parseNewNewYorkApiResponse } from "../..";
import { OrgContractStatus } from "../../models/orgContract/types";
import { orgContractToServiceStatus, serviceToOrgContract } from "../../models/orgContract";
import { FiltersRequiredError, NotImplementedError } from "../../types";
import { Observable } from "rxjs";
import { ObservableHandler } from "../../handlers";
import { parseIdFilter } from "../../handlers/filter";
import axios from "axios";
import { isServicePage } from "../../handlers/page";
class OrgContracts extends ObservableHandler {
    constructor(sdk) {
        super(sdk, "org-contracts");
        this.url = `${this.sdk.urls.baseAPIUrl}/org_contracts`;
    }
    /**
     * Finds and retrieves items based on the provided filters.
     *
     * @param filters - The filters to apply when searching for `OrgContract` items.
     *           Supports (and requires):
     *             {FilterTypes.EQ, "id"}
     * @throws FiltersRequiredError - If the provided filters do not include an ID filter.
     */
    findItems(filters) {
        const idFilter = parseIdFilter(filters);
        if (!idFilter) {
            throw new FiltersRequiredError("id");
        }
        return new Observable((subscriber) => {
            this.getOrgContracts(filters)
                .then((orgContracts) => {
                subscriber.next(orgContracts);
                subscriber.complete();
            })
                .catch((error) => {
                subscriber.error(error);
            });
        });
    }
    async getOrgContracts(filters = {}) {
        const orgContractId = filters.where?.find((filter) => filter.field === "id")
            ?.value;
        if (!orgContractId) {
            throw new FiltersRequiredError("id");
        }
        const incomingStatus = filters.where?.find((filter) => filter.field === "status")?.value.toString() ||
            OrgContractStatus.ACTIVE;
        const status = orgContractToServiceStatus(incomingStatus);
        const pageSize = filters?.paging?.size || 10;
        const url = `${this.url}?org_ids=["${orgContractId}"]&statuses=${status}`;
        return this.cache.promise(`${url}`, () => axios
            .get(`${url}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
            const rawOrgContractData = parseNewNewYorkApiResponse(res);
            const transformedData = rawOrgContractData.data.map(serviceToOrgContract);
            let results = transformedData;
            if (isServicePage(rawOrgContractData)) {
                results = {
                    page: {
                        count: rawOrgContractData.paging_info.count,
                        token: rawOrgContractData.paging_info.token,
                        size: pageSize
                    },
                    data: transformedData
                };
            }
            return results;
        })
            .catch((error) => {
            throw error;
        }));
    }
    /**
     * For right now, this is a stub to get org contracts. The implementation CRUD operations will be added in the future.
     * The BE is handling org contract creation and updates to set org contracts.
     * @param orgContract
     */
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    make(orgContract) {
        throw new NotImplementedError("make");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    saveItem(orgContract) {
        throw new NotImplementedError("save");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    async deleteItem(id) {
        throw new NotImplementedError("delete");
    }
}
export default OrgContracts;
//# sourceMappingURL=index.js.map